export const PRICE_RANGE_LIST = Object.freeze(
  ['$', '$$', '$$$', '$$$$'].map((priceRange, index) =>
    Object.freeze({ id: index + 1, name: priceRange })
  )
);
